import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import MediaQuery from "components/MediaQuery";
import { TooltipContainer } from "@outplayed/tooltips";
import { getUrl } from "@outplayed/riot-assets";
import { getRiotAssetsContext } from "@outplayed/riot-assets";
import { getPerfScore } from "lib/general-helper";
import classnames from "classnames";
import { sortTeamByRoles, getRoleSVG, numToRoleMapping } from "lib/role_helper";
import { usePerformanceScore } from "api/summonerProfileApi";
import { ReactComponent as BlueTeamplay } from "svg/blue-teamplay.svg";
import { ReactComponent as YellowHardCarry } from "svg/yellow-hard-carry.svg";
import { ReactComponent as YellowCarryKing } from "svg/yellow_carry_king.svg";
import { ReactComponent as ScoringDownArrow } from "svg/scoring-down-arrow.svg";
import { ReactComponent as ArrowDown } from "svg/triangle-arrow-down.svg";
import { ReactComponent as ArrowUp } from "svg/triangle-arrow-up.svg";

const ScoringSection = (props) => {
  const [mobileDisplayTeams, setMobileDisplayTeams] = useState(false);
  const [mainSummonerName, setMainSummoner] = useState("");
  const { data, mainSummonerName: mainSummonerNameDef, winConditionClass } = props;
  useEffect(() => {
    setMainSummoner(mainSummonerNameDef);
  }, []);
  const { match } = data;
  const { historicalData, winningTeam, matchSummary } = match;
  const { matchDuration, version, matchId } = matchSummary;
  const { postGameData, regionId } = historicalData;
  const calcMatchDuration = Math.round(matchDuration / 60);

  let mainSummonerData = {};
  const teamPerformances = { team1: [], team2: [] };
  const teamKeys = Object.keys(teamPerformances);

  let {
    data: performanceScore,
    loading,
    error,
  } = usePerformanceScore(regionId, mainSummonerNameDef, version, matchId.toString());
  if (mainSummonerName === "" || !mainSummonerName) return null;

  if (loading || error || !performanceScore) {
    return (
      <div className="not-found-user-summoner-profile not-found_loading">
        <div className="spinthatshit-loader">
          <div className="spinner"></div>
        </div>
      </div>
    );
  }
  performanceScore = performanceScore.fetchPerformanceScore;
  for (let i = 0; i < postGameData.length; i++) {
    const teamKey = postGameData[i].teamId === winningTeam ? "team1" : "team2";
    const foundScore = performanceScore.find((element) => {
      return element.summonerName === postGameData[i].summonerName;
    });
    if (foundScore) {
      teamPerformances[teamKey].push(foundScore);
    } else {
      teamPerformances[teamKey].push({});
    }

    if (teamPerformances[teamKey]) {
      const team = teamPerformances[teamKey];
      const isMainSummoner = postGameData[i].summonerName === mainSummonerName;

      teamPerformances[teamKey][team.length - 1] = {
        ...team[team.length - 1],
        perfScore:
          team[team.length - 1] && team[team.length - 1].hardCarry
            ? getPerfScore(team[team.length - 1].hardCarry, team[team.length - 1].teamplay)
            : -1,
        role: postGameData[i].role,
        championId: postGameData[i].championId,
        isMainSummoner: isMainSummoner,
        regionId: regionId,
        teamId: postGameData[i].teamId,
        summonerName: postGameData[i].summonerName,
      };

      mainSummonerData = isMainSummoner ? teamPerformances[teamKey][team.length - 1] : mainSummonerData;
    }
  }

  let maxData = {};
  teamKeys.forEach((key) => {
    teamPerformances[key] = sortTeamByRoles(teamPerformances[key]);

    if (!maxData[key]) maxData[key] = { max: 0, index: -1 };

    teamPerformances[key].forEach((teamPerf, index) => {
      if (teamPerf.perfScore > maxData[key].max) {
        maxData[key].max = teamPerf.perfScore;
        maxData[key].index = index;
      }
    });
  });

  Object.entries(maxData).forEach(([key, { index }]) => {
    if (index >= 0) {
      teamPerformances[key][index].isMaxOnTeam = true;
    }
  });

  let teamName = teamPerformances["team1"][0].teamId === 100 ? "Blue" : "Red";
  const title1 = [`Victory - ${calcMatchDuration} min`, `(${teamName} Side)`];
  teamName = teamName === "Blue" ? "Red" : "Blue";
  const title2 = ["Defeat", `(${teamName} Side)`];

  return (
    <div>
      <MediaQuery min="MOBILE_MEDIUM" max="DESKTOP_LARGE">
        <div className="scoring-container">
          <div className="team-container">
            <TeamSection
              winConditionClass={winConditionClass}
              team={teamPerformances["team1"]}
              titleData={title1}
              titleColor={"blue"}
              setMainSummoner={setMainSummoner}
            />
            <TeamSection
              winConditionClass={winConditionClass}
              team={teamPerformances["team2"]}
              titleData={title2}
              titleColor={"red"}
              setMainSummoner={setMainSummoner}
            />
          </div>
          <div className="right-section">
            <MainSummonerSection summonerData={mainSummonerData} winConditionClass={winConditionClass} />
            <SubscoreSection summonerData={mainSummonerData} />
          </div>
        </div>
      </MediaQuery>
      <MediaQuery min="MOBILE_SMALL" max="MOBILE_SMALL">
        <div className="scoring-container">
          <div className="right-section">
            <MainSummonerSectionMobile
              setMobileDisplayTeams={setMobileDisplayTeams}
              mobileDisplayTeams={mobileDisplayTeams}
              title1={title1}
              title2={title2}
              teamName={teamName}
              summonerData={mainSummonerData}
              teamPerformances={teamPerformances}
              setMainSummoner={setMainSummoner}
            />
            <SubscoreSection summonerData={mainSummonerData} />
          </div>
        </div>
      </MediaQuery>
    </div>
  );
};

const TeamSection = (props) => {
  const [summonerProfileIndex, setSummonerProfileIndex] = useState(-1);
  useEffect(() => {
    const team = props.team;
    for (let i = 0; i < team.length; i++) {
      if (team[i].isMainSummoner) {
        setSummonerProfileIndex(i);
        return;
      }
    }
  }, []);
  const { team, titleData, titleColor, setMainSummoner } = props;
  return (
    <div>
      <div className="team-title">
        <div className={`title-start ${titleColor}`}>{titleData[0]}&nbsp;</div>
        <div>{titleData[1]}</div>
      </div>
      {team.map((summonerData, index) => {
        return (
          <SummonerRow
            winConditionClass={props.winConditionClass}
            key={index}
            summonerData={summonerData}
            setMainSummoner={setMainSummoner}
            isSummonerProfile={index == summonerProfileIndex}
          />
        );
      })}
    </div>
  );
};

const SummonerRow = (props) => {
  const { getChampionName, getChampionImg } = getRiotAssetsContext();
  const { summonerData, setMainSummoner, isSummonerProfile, winConditionClass } = props;
  const { championId, summonerName, perfScore, isMaxOnTeam } = summonerData;

  const championImg = getChampionImg(championId);
  const championName = getChampionName(championId);
  const isMainSummonerClass = summonerData.isMainSummoner ? "chosen" : "";
  const orangeHighlightClass = isSummonerProfile ? "highlight" : "";
  const isMaxSummonerClass = isMaxOnTeam ? "max" : "";
  const perfScoreText = perfScore <= 0 ? "-" : perfScore;
  const clickableClass = perfScore <= 0 ? "" : "clickable";

  return (
    <div
      className={`summoner ${isMainSummonerClass} ${clickableClass} ${winConditionClass}`}
      onClick={perfScore > 0 ? () => setMainSummoner(summonerName) : null}
    >
      <div className="name-icon">
        <div className="champion-face">
          <img src={championImg} alt={championName} />
        </div>
        <div className={`summoner-name ${orangeHighlightClass}`}>{summonerName}</div>
      </div>
      <div className={`perf-score ${isMaxSummonerClass}`}>
        {perfScoreText}
        {isMaxOnTeam && (
          <div style={{ position: "relative", left: "-125px", top: "-10px" }}>
            <div style={{ position: "absolute" }}>
              <YellowCarryKing width="20px" height="20px" />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

const MainSummonerSectionMobile = (props) => {
  const { getChampionName, getChampionImg } = getRiotAssetsContext();
  const { summonerData, teamPerformances, setMainSummoner, title1, title2, mobileDisplayTeams, setMobileDisplayTeams } = props;
  const { perfScore, hardCarry, teamplay, championId } = summonerData;
  const championImg = getChampionImg(championId);
  const championName = getChampionName(championId);
  const hardCarryPerc = Math.round((hardCarry / (hardCarry + teamplay)) * 100);

  return (
    <div>
      <div
        className="main-summoner-section-mobile"
        style={!mobileDisplayTeams ? { marginBottom: "25px" } : {}}
        onClick={() => setMobileDisplayTeams(!mobileDisplayTeams)}
      >
        <div className="icon">
          <img width="40px" height="40px" src={championImg} alt={championName} />
        </div>
        <div>{summonerData.summonerName}</div>
        <div className="score-text">
          Score: <span>{perfScore}</span>
        </div>
        <ScoringDownArrow width="8px" height="4px" />
      </div>
      {mobileDisplayTeams && (
        <div className="mobile-team-section">
          <TeamSection
            team={teamPerformances["team1"]}
            titleData={title1}
            titleColor={"blue"}
            setMainSummoner={setMainSummoner}
          />
          <TeamSection team={teamPerformances["team2"]} titleData={title2} titleColor={"red"} setMainSummoner={setMainSummoner} />
        </div>
      )}
      <PlaystyleWidget hardCarryPerc={hardCarryPerc} />
    </div>
  );
};

const MainSummonerSection = (props) => {
  const { getChampionName, getChampionImg } = getRiotAssetsContext();
  const { summonerData, winConditionClass } = props;
  const { perfScore, hardCarry, teamplay, championId, role } = summonerData;
  const championImg = getChampionImg(championId);
  const championName = getChampionName(championId);
  const roleImg = getRoleSVG(numToRoleMapping(role));
  const hardCarryPerc = Math.round((hardCarry / (hardCarry + teamplay)) * 100);

  return (
    <div className="main-summoner-section">
      <div className={classnames("scoring-header", winConditionClass)}>
        <div className="icon">
          <img width="40px" height="40px" src={championImg} alt={championName} />
        </div>
        <div className="role-icon-position">
          <div className="role-img">{roleImg}</div>
        </div>
        <div>{`${summonerData.summonerName}'s Carry Score`}</div>
        <div className="score-display">{perfScore}</div>
      </div>
      <PlaystyleWidget hardCarryPerc={hardCarryPerc} />
    </div>
  );
};

const PlaystyleWidget = (props) => {
  const { hardCarryPerc } = props;

  return (
    <div className="playstyle-section">
      <div className="playstyle-label">Playstyle</div>
      <div className="playstyle-widget">
        <YellowHardCarry width="16px" height="16px" />
        <div style={{ marginLeft: "14px" }}>{`${hardCarryPerc}%`}</div>
        <div className="playstyle-bar-outer">
          <div className="playstyle-bar-inner" style={{ width: `${hardCarryPerc}%` }} />
        </div>
        <div style={{ marginRight: "14px" }}>{`${100 - hardCarryPerc}%`}</div>
        <BlueTeamplay width="16px" height="16px" />
      </div>
    </div>
  );
};

const getPerc = (num, subscore) => {
  if (subscore === "visionScore") {
    return "" + (num || 0).toFixed(0);
  } else if (subscore === "kpOverGs" || subscore === "finalLvlDiff") {
    return "" + (num || 0).toFixed(2);
  }
  return "" + Math.round((num || 0) * 100) + "%";
};

const SubscoreSection = (props) => {
  const { summonerData } = props;
  const { role } = summonerData;
  const teamplay = summonerData["teamplay"];
  const hardCarry = summonerData["hardCarry"];
  const subscores = ["goldShare", "damageShare", "finalLvlDiff", "killParticipation", "visionScore", "kpOverGs"];
  const titles = ["Gold Share", "Damage Share", "Level Difference", "Kill Participation", "Vision Score", "Efficiency"];
  const abbrs = ["GS", "DS", "LD", "KP", "VS", "EF"];

  const scoreTooltips = [
    "is your % of your team’s total gold.",
    "is your % of your team’s total damage.",
    "is your final level difference vs opposing laner.",
    "is your % of takedowns (kills + assists) of team’s total kills.",
    "measures how much vision you influenced this game.",
    "measures your impact given the resources allocated. It is your KP divided by GS.",
  ];

  const subScoresData = subscores.map((subscore, index) => {
    let calcDiff =
      (summonerData["" + subscore + "Total"] - summonerData["" + subscore + "Agg"]) / summonerData["" + subscore + "Agg"];
    calcDiff = Math.round(calcDiff * 100);
    if (subscore === "finalLvlDiff") {
      calcDiff = Math.round(((summonerData[subscore] - 75) / 75) * 100);
    }
    if (calcDiff >= 1000) calcDiff = 999;
    else if (calcDiff <= -1000) calcDiff = -999;

    return {
      [subscore]: Math.round(summonerData[subscore]),
      [subscore + "Agg"]: getPerc(summonerData["" + subscore + "Agg"], subscore),
      [subscore + "Total"]: getPerc(summonerData["" + subscore + "Total"], subscore),
      role: summonerData.role,
      diff: calcDiff,
      title: titles[index],
      abbr: abbrs[index],
      color: index < 3 ? "yellow" : "green",
    };
  });

  const carryScores = subScoresData.slice(0, 3);
  const teamplayScores = subScoresData.slice(3, 6);

  return (
    <div className={`subscores-container`}>
      <div className="subscores-subsection">
        <div className="subscores-title">
          <YellowHardCarry width="16px" height="16px" />
          <div style={{ marginLeft: "10px" }}>Hard Carry</div>
          <div className="avg-box">
            <div>Avg: 75</div>
          </div>
          <div className="score-circle">{hardCarry}</div>
        </div>
        <div className="divider" />
        <div style={{ position: "relative" }}>
          <div className="three-fourths-line" />
        </div>
        {carryScores.map((subscoreData, index) => {
          return (
            <IndividualSubscore key={index} data={subscoreData} subscore={subscores[index]} scoreTooltip={scoreTooltips[index]} />
          );
        })}
      </div>
      <div className="subscores-subsection blue">
        <div className="subscores-title">
          <BlueTeamplay width="16px" height="16px" />
          <div style={{ marginLeft: "10px" }}>Teamplay</div>
          <div className="avg-box">
            <div>Avg: 75</div>
          </div>
          <div className="score-circle">{teamplay}</div>
        </div>
        <div className="divider" />
        <div style={{ position: "relative" }}>
          <div className="three-fourths-line" />
        </div>
        {teamplayScores.map((subscoreData, index) => {
          return (
            <IndividualSubscore
              key={index}
              data={subscoreData}
              subscore={subscores[3 + index]}
              scoreTooltip={scoreTooltips[3 + index]}
            />
          );
        })}
      </div>
    </div>
  );
};

const IndividualSubscore = (props) => {
  const { data, subscore, scoreTooltip } = props;
  const { title, abbr, color, role } = data;
  const score = data["" + subscore];
  const avgStat = data["" + subscore + "Agg"];
  const yourStat = data["" + subscore + "Total"];
  const scoreText = score < 0 ? "-" : score;
  const scoreClass = data[subscore] >= 100 ? "highlighted" : data[subscore] >= 75 ? "colored" : "";
  let scorePerc = Math.round(data[subscore]);
  if (scorePerc < 0) scorePerc = 0;
  if (scorePerc > 100) scorePerc = 100;
  const diffClass = data[subscore] >= 75 ? "blue" : "red";
  const tooltipInfo = (
    <ScoreTooltip
      role={role}
      scoreTooltip={scoreTooltip}
      diff={data["diff"]}
      diffClass={diffClass}
      avgStat={avgStat}
      yourStat={yourStat}
      color={color}
      title={title}
      abbr={abbr}
    />
  );

  return (
    <TooltipContainer
      tooltipInfo={tooltipInfo}
      disableTooltip={!scoreTooltip}
      customStyle={{ backgroundColor: "#25254b", padding: "12px 12px" }}
      customArrowStyle={{ backgroundColor: "#25254b" }}
    >
      <div className={`individual-subscore ${scoreClass}`}>
        <div className="title-text">{title}</div>
        <div className="outer-bar">
          <div className="inner-bar" style={{ width: `${scorePerc}%` }} />
        </div>
        <div className="score-text">{scoreText}</div>
      </div>
    </TooltipContainer>
  );
};

const ScoreTooltip = (props) => {
  const { scoreTooltip, avgStat, yourStat, title, abbr, color, diffClass, diff, role } = props;
  const preTooltip = "" + title + " (" + abbr + ") ";
  const roleImg = getRoleSVG(numToRoleMapping(role));

  return (
    <div className="score-tooltip">
      <div className={`tooltip-text ${color}`}>
        <span>{preTooltip}</span>
        {scoreTooltip}
      </div>
      <div className="stats-section">
        <div className="stat-subsection">
          <div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "65px" }}>
            <div style={{ marginBottom: "3px" }} className="role-img">
              {roleImg}
            </div>
            <div style={{ marginLeft: "5px" }}>Avg {abbr}:</div>
          </div>
          <div className="divider" />
          <div className="stat-display">{avgStat}</div>
        </div>
        <div className="stat-subsection">
          <div>Your {abbr}:</div>
          <div className="divider" />
          <div className="stat-display" style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
            {yourStat}
            <div className={`tooltip-diff-box ${diffClass}`}>
              <div>
                {diffClass === "red" && <ArrowDown width="4px" height="4px" className="down-arrow" />}
                {diffClass === "blue" && <ArrowUp width="4px" height="4px" className="up-arrow" />}
                <span style={{ marginLeft: "2px" }}>{Math.abs(diff)}%</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ScoringSection;
